import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Panel, DropdownButton, NavItem } from "react-bootstrap";
import { IoDownload, IoTrash, IoEllipsisVertical } from "react-icons/io5";

import { orderBy } from "lodash";

import matchSorter from "match-sorter";

import { formatDate } from "../../helpers/date";

const ProjectAttachmentsList = ({
  project,
  search,
  isMobile,
  onClickDownload,
  onClickDelete
}) => {
  let projectAttachmentsView = (
    <div
      className="content-wrapper vertical-center -full"
      style={{ margin: 0 }}
    >
      <h4>No attachments available</h4>
    </div>
  );

  if (project) {
    let { attachments } = project;

    if (search) {
      attachments = matchSorter(project.attachments, search, {
        keys: [(row) => formatDate(row.created_on, "MM/dd/yyyy")]
      });
    }

    if (attachments && attachments.length) {
      projectAttachmentsView = (
        <Row>
          {orderBy(attachments, "modified_on", "desc").map((attachment) => {
            const timestamp = formatDate(
              attachment.created_on,
              !isMobile ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"
            );

            return (
              <Panel
                bsStyle="info"
                key={attachment.id}
                className="attachment-panel"
              >
                <Panel.Body>
                  <Col md={8} xs={5}>
                    <p style={{ textOverflow: "ellipsis" }}>
                      {attachment.name || attachment.path}
                      {attachment.user && ` - ${attachment.user}`}
                    </p>
                  </Col>
                  <Col md={3} xs={5}>
                    <p className="pull-right">{timestamp}</p>
                  </Col>
                  <Col md={1} xs={2}>
                    <div className="actions pull-right">
                      <DropdownButton
                        title={
                          <span>
                            <IoEllipsisVertical />
                          </span>
                        }
                        id="dropdown"
                      >
                        <NavItem onClick={() => onClickDownload(attachment.id)}>
                          <IoDownload />
                          View
                        </NavItem>
                        <NavItem onClick={() => onClickDelete(attachment.id)}>
                          <IoTrash />
                          Delete
                        </NavItem>
                      </DropdownButton>
                    </div>
                  </Col>
                </Panel.Body>
              </Panel>
            );
          })}
        </Row>
      );
    }
  }

  return <div>{projectAttachmentsView}</div>;
};

ProjectAttachmentsList.propTypes = {
  project: PropTypes.object.isRequired,
  search: PropTypes.string,
  onClickDownload: PropTypes.func,
  onClickDelete: PropTypes.func,
  isMobile: PropTypes.bool
};

export default ProjectAttachmentsList;
